import React, { useContext, useState } from 'react'
import { ArrowDown, ArrowUp, ChevronDown, ChevronUp } from 'react-bootstrap-icons'
import { observer } from 'mobx-react-lite'
import { BrowseContext } from '../../../contexts/BrowseContext'

export default observer(function SortByDropdown({
  sortDirection,
  editSortDirection,
  editSortAttribute
 }) {
  const dropdownOptions = ['Name', 'Updated at', 'Created at']
  const [showDropdown, setShowDropdown] = useState(false)
  const [sortingBy, setSortingBy] = useState(dropdownOptions[0])

  return (
    <div className='flex items-center relative'>
      <button
        type="button"
        className='h-7 w-7 hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter flex items-center justify-center rounded-lg mr-2 dark:text-white'
        onClick={() => editSortDirection()}
      >
        {sortDirection === 'desc' ? <ArrowDown /> : <ArrowUp />}
      </button>
      <button
        className='flex items-center justify-between gap-1 dark:text-white'
        onClick={() => {
          setShowDropdown(!showDropdown)
        }}
      >
        <span className='font-bold text-sm'>{sortingBy}</span>
        { showDropdown ? <ChevronUp /> : <ChevronDown /> }
      </button>
      {
        showDropdown && (
          <div
            className='flex flex-col gap-1 shadow z-30 absolute top-5 right-0 bg-white dark:bg-rb-dark-mode w-[150px] mt-2 border-1 dark:border-rb-dark-mode-lighter rounded-md'
          >
            {
              dropdownOptions.map(option => (
                <button
                  className={`w-full hover:bg-gray-100 dark:hover:bg-rb-dark-mode-lighter flex items-center p-2 dark:text-white`}
                  onClick={() => {
                    setShowDropdown(!showDropdown)
                    setSortingBy(option)
                    editSortAttribute(option)
                  }}
                >
                  {option}
                </button>
              ))
            }
          </div>
        )
      }
    </div>
  )
})
